export default __webpack_public_path__ + "static/media/yo7.b7260f72.png";